import { gql } from "@apollo/client";
export const CH_REPORT_TYPE = "all_findings_v2";
export const DEFAULT_REPORT_TYPE = "all_findings";
export const RESOURCES_REPORT_TYPE = "all_resources_v2";
export const GET_CSV_COLUMNS_OPTIONS = gql`
  query GetCSVColumnsOptions {
    reports_menu {
      report_options {
        type
        description
        fields {
          key
          header_name
        }
      }
    }
  }
`;

export const GET_COSTUMER_CSV_COLUMNS = gql`
  query GetCostumerCSVColumns(
    $report_type: String = "${DEFAULT_REPORT_TYPE}"
    $remediation_queue_id: String
    $endpoint_type: EndpointType
  ) {
    default_report_parameters(
      report_type: $report_type
      remediation_queue_id: $remediation_queue_id
      endpoint_type: $endpoint_type
    )
  }
`;

export const DOWNLOAD_FINDINGS = gql`
  mutation downloadFindings(
    $report_type: String = "${DEFAULT_REPORT_TYPE}"
    $save_as_default: Boolean = true
    $name_template: String!
    $filters_config: FiltersConfigInput
    $fields: [String]!
    $order_by: [[String]]
  ) {
    generate_report(
      report_type: $report_type
      save_as_default: $save_as_default
      name_template: $name_template
      filters_config: $filters_config
      fields: $fields
      order_by: $order_by
    ) {
      task_id
    }
  }
`;
